<template>
	<div
		class="pullquote"
		v-if="data.pullquote"
	>
		<div class="quotemark">
			<img src="@/images/quote.svg?inline" />
		</div>
		<h4>{{ data.pullquote.quote }}</h4>
		<h5>{{ data.pullquote.author }}</h5>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { Resource } from '@/interfaces/resourceInterface';

export default defineComponent({
	props: {
		data: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
});
</script>

<style scoped lang="scss">
@use '@/styles/utils';

.pullquote {
	-webkit-column-break-inside: avoid;
	position: relative;
	break-inside: avoid;
	page-break-inside: avoid;
	margin: 5rem auto 5.5rem auto;
	border-top: 4px solid rgb(var(--rs-color-brand-cherry));
	border-bottom: 4px solid rgb(var(--rs-color-brand-cherry));
	padding: 4rem var(--rs-layout-content-padding);
	max-width: 520px;

	.quotemark {
		position: absolute;
		top: -13px;
		left: 50%;
		margin-left: -35px;
		background-color: white;
		width: 70px;
		text-align: center;
	}

	h4 {
		margin: 0;
		color: rgb(var(--rs-typography-font-body-color));
		font-size: 2.3rem;
		line-height: 1.3;
		text-align: center;
	}

	h5 {
		position: absolute;
		left: 50%;
		transform: translate(-50%, 30px);
		margin: 0;
		background-color: white;
		padding: 0 15px;
		color: rgb(var(--rs-color-brand-cherry));
		font-weight: bold;
		font-size: 1.9rem;
		font-family: var(--rs-typography-font-body);
		white-space: nowrap;
	}
}

@media print {
	.pullquote {
		margin: 3rem;
		border-top-width: 2px;
		border-bottom-width: 2px;
		padding: 2.5rem var(--rs-layout-content-padding);

		.quotemark {
			top: -11px;
			margin-left: -20px;
			width: 40px;

			img {
				width: 25px;
			}
		}

		h4 {
			color: black;
			font-size: 2rem;
		}

		h5 {
			transform: translate(-50%, 12px);
			font-size: 1.8rem;
		}
	}
}
</style>
